import { User } from "lucide-react";

export interface PriceAndCapacityProps {
  priceFrom: number;
  capacity: number;
  additionalCapacity?: number;
}

export const PriceAndCapacity = ({
  // TODO: uncomment when phase 3 is completed from BE
  // @ts-ignore
  // eslint-disable-next-line
  priceFrom,
  capacity,
  additionalCapacity = 0,
}: PriceAndCapacityProps) => {
  return (
    <div className="c-price-and-capacity">
      {/* TODO: uncomment when phase 3 is completed from BE */}
      {/*<h6 className="c-price-and-capacity__price u-p0 u-text-dark">*/}
      {/*<span className="u-fw-600">*/}
      {/*{t("from")} {formatCurrency(priceFrom, "EUR", 0)}*/}
      {/*</span>*/}
      {/*</h6>*/}
      <div className="c-price-and-capacity__capacity u-p0">
        <span className="u-p0 u-text-accent u-fw-500">{capacity}</span>
        <User size={18} strokeWidth={"2.5"} color={"var(--color-primary)"} />
        {additionalCapacity > 0 && (
          <>
            <span className="c-price-and-capacity__separator">+</span>
            <span className="u-p0 u-text-accent u-fw-500">{additionalCapacity}</span>
            <User size={18} strokeWidth={"2.5"} color={"var(--color-primary)"} />
          </>
        )}
      </div>
    </div>
  );
};
